/* istanbul ignore file */
import AuthService from "@/services/authService.js";

export default {
  install(app) {
    app.config.globalProperties.$auth = AuthService;
    app.provide("auth", AuthService);
  },
};
